import { Injectable } from '@angular/core';
import { Employer, Member } from '../models/employer.type';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { BrReg } from '../../auth/routes/models/brReg.type';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class EmployerService {
  private baseUrl = environment.apis.employerApi;


  constructor(
    private http: HttpClient,
    // private msalService: MsalService
  ) {}

  async isEmployer(): Promise<any> {
  //  const account = this.msalService.instance.getActiveAccount();
  //   if (!account) throw new Error('Not logged in');

 
    // temp idtoken
    const requestUrl = `${this.baseUrl}/employerservices/is-employer`;


    return firstValueFrom(this.http.get<any>(requestUrl));
  }

  async getEmployers(): Promise<any> {
    // const account = this.msalService.instance.getActiveAccount();
    //  if (!account) throw new Error('Not logged in');
 
  
     // temp idtoken
    //  const idToken = account.idToken ?? '';
    //  console.log(idToken);
     const requestUrl = `${this.baseUrl}/employerservices/get-employers`;
 
 
     return firstValueFrom(this.http.get<any>(requestUrl));
   }

  async getOrganizationFromBrReg(orgNumber: string): Promise<BrReg> {

    const requestUrl = `${this.baseUrl}/employerservices/brReg?orgNumber=${orgNumber}`;

    return firstValueFrom(this.http.get<BrReg>(requestUrl));

  }

  async getDeductionListsByOrganization(organizationNumber: number): Promise<any> {
    const requestUrl = `${this.baseUrl}/employerservices/periods/${organizationNumber}`;
    return firstValueFrom(this.http.get<any>(requestUrl));
  }
  

  // async getEmployer(): Promise<Employer> {
  //   // simulerer async kall
  //   return new Promise(resolve => {
  //     setTimeout(() => resolve(this.mockEmployer), 500); 
  //   });
  // }
}
